<template>
  <div class="layout-table">
   <slot></slot>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  config: {  // 配置项
    type: Object,
    default: {},
  },
});
const { config } = props

const header = computed(() => {
  console.log('config', config);
  var data = config
  if(data.logo){
    data.logo = data.logo.replace('{theme}', config.theme) || null
  }
   return data
});



</script>
<style lang="less">
.layout-table{
  height: 44px;
  line-height: 44px;
  background: #ffffff;
}
</style>